import { render } from "./NavBarToggler.vue?vue&type=template&id=508cdaf0&scoped=true"
import script from "./NavBarToggler.vue?vue&type=script&lang=js"
export * from "./NavBarToggler.vue?vue&type=script&lang=js"

import "./NavBarToggler.vue?vue&type=style&index=0&id=508cdaf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508cdaf0"]])

export default __exports__